import React from 'react'
import { ClipboardMinus, ClipboardX } from 'react-bootstrap-icons'

const Attendee = ({
    user = {},
    onClick = () => {},
    isDropIn
}) => {
    const Icon = isDropIn ? ClipboardX : ClipboardMinus
    return ( 
        <div
            style={{
                border: 'solid 1px rgb(66, 122, 54)',
                borderRadius: '5px',
                paddingLeft: '5px',
                padding: '5px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '5px'
            }}
        >
            <Icon
                color='rgb(187, 72, 63)'
                onClick={() => onClick()}
                size={25}
                style={{
                    cursor: 'pointer'
                }}
            />
            {user.lastName}, {user.firstName}

        </div>
    )
}

export default Attendee
